import { useI18n } from './i18n';

export const TAG_KINDS = [
  { kind: 'setup', label: 'Setups' },
  { kind: 'mistake', label: 'Mistakes' },
  { kind: 'context', label: 'Context' },
];

// The kind of a tag name, looked up in the trader's library. Tags that were
// removed from the library but are still on trades count as context.
export function tagKind(name, library) {
  const match = library.find((t) => t.name.toLowerCase() === name.toLowerCase());
  return match ? match.kind : 'context';
}

export function TagChip({ name, kind, selected, onClick, onRemove }) {
  const { t } = useI18n();
  const classes = `tag-chip tag-${kind}${selected ? ' selected' : ''}${onClick ? ' clickable' : ''}`;
  if (onClick) {
    return (
      <button type="button" className={classes} onClick={onClick} aria-pressed={selected}>
        {name}
      </button>
    );
  }
  return (
    <span className={classes}>
      {name}
      {onRemove && (
        <button type="button" className="tag-remove" onClick={onRemove} aria-label={t('Remove {name}', { name })}>
          &times;
        </button>
      )}
    </span>
  );
}
